/*
This fixes a bug on subdomain or custom domain profiles where it's rendering marketing pages
*/
export default function profileRedirect() {
  /*
   ** Only run on client-side and only in production mode
   */
  if (process.env.NODE_ENV !== 'production' || process.server) return;

  const hostname = location.hostname;
  const isCustomDomain =
    !hostname.includes('localhost') && !hostname.includes('campsite.bio');
  const subdomain = hostname.split('.')[0];
  const isSubdomain =
    hostname.includes('campsite.bio') &&
    subdomain !== 'campsite' &&
    subdomain !== 'staging';
  const pathname = location.pathname;
  // Handle custom domains and subdomains
  if (isCustomDomain || isSubdomain) {
    // Redirect non root
    if (pathname !== '/') window.location = '/';
  }
}
